// Two classes (0,2,0) outrank the skin reset (0,1,2) the way the shared
// ComposerToolbarEnd module does for the end slot — no z-index. One width holds both
// labels, so a mode switch never moves the toolbar slot's edge.
:global(.tox-editor-header) .composerModeToggle {
  width: 9rem;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-size: var(--bs-btn-font-size);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-secondary-color);

  &:hover {
    color: var(--bs-body-color);
  }

  &:focus-visible {
    outline: 0;
    box-shadow: var(--bs-btn-focus-box-shadow);
  }
}
